// import external dependencies
import * as controller from '../interactive3d/controller';

export default {
  init() {
    // JavaScript to be fired on the rigo cheneau page
    $('.sidebar-fixed .page_item > a').on('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();

      let target = $(evt.target);
      $('html').animate({
        scrollTop: $(target.attr('href')).offset().top,
      }, 750);
    });

    const container = document.getElementsByClassName('interactive-3d__container')[0];
    controller.init(container);
  },
  finalize() {
    // JavaScript to be fired on the rigo cheneau page, after the init JS
  },
};
